import React from 'react';

const LoadingFallback = () => {
    return (
        <div className="d-flex flex-column align-items-center justify-content-center"
            style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                padding: "20px",
                borderRadius: "10px",
            }}>
            <div className="spinner-border text-black" role="status">
                <span className="sr-only"></span>
            </div>
            <h4 className="text-black text-bold mt-2">Loading...</h4>
        </div>
    );
}

export default LoadingFallback;
